import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducer/index';
import thunk from 'redux-thunk';
import api from '../middleware/api';


// the next line is the important part
const createStoreWithMiddleware = applyMiddleware(thunk, api)(createStore);

export default function configureStore() {
    return createStoreWithMiddleware(rootReducer);
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js